import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import jennifer from "./Staff/DrVan.jpg";
import catherine from "./Staff/DrBall.jpg";
import vinston from "./Staff/drvinstonvan.jpg";

class MeetOurTeam extends React.Component {
  render() {
    return (
      <div>
        <Container>
          <h1>Meet Our Dentists</h1>
          <Row className="mx-auto py-5">
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <img
                className="p-4"
                src={jennifer}
                alt="Dr. Jennifer Van, DMD"
                style={{
                  backgroundImage:
                    "linear-gradient(315deg, #ffffff 0%, #d7e1ec 74%)",
                  borderRadius: "0",
                  width: "100%",
                  height: "auto",
                }}
              ></img>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <div className="px-1 py-4">
                <h3 className="pb-4">Dr. Jennifer T. Van, DMD</h3>
                <p>
                  Dr. Van attended Florida International University and then
                  Nova Southeastern University College of Dental Medicine where
                  she earned her Doctorate of Dental Medicine.
                </p>
                <p>
                  Dr. Van loves every aspect of dentistry, but what she loves
                  most is making a nervous patient feel so comfortable that they
                  can fall asleep in their chair during procedures. Dr. Van's
                  life long goal is to be able to use her talents and skills to
                  help those less fortunate. Her charities include rescuing and
                  reforming human sex trafficked victims, feeding the homeless,
                  and sending supplies to underserved communities. One day she
                  hopes to go to the disadvantaged countries and give free
                  dental treatment to their citizens. Dr. Van is married with 5
                  wonderful children. In her spare time, she loves to sing and
                  cook for her small (lol) family.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="mx-auto pb-5">
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <img
                className="p-4"
                src={catherine}
                alt="Dr. Catherine Ball, DMD"
                style={{
                  backgroundImage:
                    "linear-gradient(315deg, #ffffff 0%, #d7e1ec 74%)",
                  borderRadius: "0",
                  width: "100%",
                  height: "auto",
                }}
              ></img>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <div className="px-1 py-4">
                <h3 className="pb-4">Dr. Catherine S. Ball, DMD</h3>
                <p>
                  Dr. Ball is a graduate of the University of Alabama at
                  Birmingham School of Dentistry and holds a Bachelor of Science
                  from the University of Georgia.
                </p>
                <p>
                  She is a native of central Florida and has enjoyed practicing
                  dentistry in St. Cloud for over 10 years. Dr. Ball has always
                  had a love for science and helping people, and found both in
                  her career as a dentist. She treats all patients with kindness
                  and loves to help educate them about their dental health so
                  they can better understand and take care of their smiles. In
                  her time away from the office, she enjoys traveling near and
                  far with her husband and two children. She also stays busy
                  cheering for the Georgia Bulldogs, cooking, and enjoying the
                  local theme parks.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="mx-auto pb-4">
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <img
                className="p-4"
                src={vinston}
                alt="Dr. Vinston Van, DMD"
                style={{
                  backgroundImage:
                    "linear-gradient(315deg, #ffffff 0%, #d7e1ec 74%)",
                  borderRadius: "0",
                  width: "100%",
                  height: "auto",
                }}
              ></img>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <div className="px-1 py-4">
                <h3 className="pb-4">Dr. Vinston Van, DMD</h3>
                <p>
                  Dr. Vinston Van is a dedicated and compassionate dentist committed to delivering exceptional, patient-centered care. Born in Arkansas, Dr. Van graduated Summa Cum Laude from Lyon College and went on to pursue his DMD degree at University of Florida!
                </p>
                <p>
                  With a strong foundation in preventive, restorative, and cosmetic dentistry, Dr. Van focuses on helping patients achieve and maintain healthy, confident smiles. Known for a meticulous approach and attention to detail, he takes the time to understand each patient’s individual needs while ensuring a comfortable and positive experience.
                </p>
                <p>
                  Outside of the office, Dr. Van enjoys expressing his creativity through DJing, staying active through regular workouts, and spending quality time with his family. His well-rounded lifestyle reflects his belief in balance, wellness, and building meaningful connections both in and out of the dental office.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default MeetOurTeam;
